import React from "react";

function Tv(){
    return(
        <div>
<section className="internal_wraper">
<div className="container">
<div className="row">
    <div className="col-12 mt-5 pt-5">
<h1 className="font-weight-bold">
Tv
</h1>
    </div>
</div>
</div>
</section>
        </div>
    );
};

export default Tv;